import Typography from '@mui/material/Typography'
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined'

const zahra = (
  <Typography variant='subtitle2' color='textSecondary' sx={{ pl: 1 }}>
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> 5x UAE National Champion<br />
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> Olympic Qualifications candidate<br />
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> 2019 Special Olympics Athlete Engagement Committee Member<br />
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> 2019 Torch bearer Special Olympics MENA Games
  </Typography>
)

const diana = (
  <Typography variant='subtitle2' color='textSecondary' sx={{ pl: 1 }}>
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> Master of Sports of Russia<br />
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> Category III Judge in Singles<br />
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> Strong in Technical Choreography, performance optimisation and methodological documentation<br />
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> Experienced in training Ultra-C elements
  </Typography>
)

const andrei = (
  <Typography variant='subtitle2' color='textSecondary' sx={{ pl: 1 }}>
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> National French Champion<br />
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> 3x participant in World Championships, 2x European Figure Skating Championships, Grand Prix, Junior Grand Prix, Russian National Championship<br />
  </Typography>
)

const attila = (
  <Typography variant='body2' color='textSecondary' sx={{ pl: 1 }}>
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> ISU Judge / Singles, Pairs & Ice Dance<br />
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> ISU Technical Controller / Singles<br />
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> ISU Seminar Host<br />
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> UAEWSF Coach Examiner
  </Typography>
)

const bohdan = (
  <Typography variant='body2' color='textSecondary' sx={{ pl: 1 }}>
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> Single and Pairs Skating.<br />
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> Principal soloist of Imperial ice Stars, Theatre on ice.<br />
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> Rehearsal director and artist Moscow Circus On  ice-team<br />
  </Typography>
)

const mark = (
  <Typography variant='body2' color='textSecondary' sx={{ pl: 1 }}>
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> UAE National Team Coach.<br />
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> Coaching experience since 2014<br />
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> In Emirates Skating Club since 2022
  </Typography>
)

const roquiya = (
  <Typography variant='body2' color='textSecondary' sx={{ pl: 1 }}>
    <b>WELCOME TO EMIRATES SKATING CLUB!</b><br />
    Our staff are committed to guiding you to reach your goals, encourage your passion, pursue your dreams and achieve your maximum potential. Our mission statement is to, &quot;Encourage the sport of figure skating in UAE. It is to develop mutual respect, fellowship, self-discipline, fairness, team spirit, self-reliance, poise and self-confidence within an environment of the highest standards of leadership, professionalism and good sportsmanship&quot;.
  </Typography>
)

const lilibeth = (
  <Typography variant='body2' color='textSecondary' sx={{ pl: 1 }} />
)

const elen = (
  <Typography variant='body2' color='textSecondary' sx={{ pl: 1 }}>
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> Multiple Champion of Armenia.<br />
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> Participant of International Competitions, Europe Championship.<br />
  </Typography>
)

const jhovet = (
  <Typography variant='body2' color='textSecondary' sx={{ pl: 1 }} />
)

const veronika = (
  <Typography variant='body2' color='textSecondary' sx={{ pl: 1 }}>
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> 3x World Champion.<br />
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> 6x National Champion as a member of Synchronized Skating Team “Paradise”.<br />
    <CircleOutlinedIcon size='small' color='primary' sx={{ verticalAlign: 'text-top' }} /> Master of Sport of International level.<br />
  </Typography>
)

const king = (
  <Typography variant='body2' color='textSecondary' sx={{ pl: 1 }} />
)

export const teams = [
  {
    name: 'ROQUIYA COCHRAN',
    title: 'President, UAE',
    flag: '🇦🇪',
    nation: 'AE',
    description: roquiya,
    citation: '',
    image: 'roquiya',
    set: 'all abu-dhabi management dubai'
  },
  {
    name: 'ZAHRA LARI',
    title: 'CEO and Figure Skating Coach',
    flag: '🇦🇪',
    nation: 'AE',
    description: zahra,
    citation: 'There will always be people against you, people doubting you and people not believing in you. Just trust yourself and prove them wrong.',
    image: 'zahra',
    education: 'BS of Science in Environment Health & Safety',
    set: 'all abu-dhabi management dubai ice-team'
  },
  {
    name: 'ATTILA BALAZS SOOS',
    title: 'ESC Advisor',
    flag: '🇭🇺',
    nation: 'HU',
    description: attila,
    citation: 'It always seems impossible until it\'s done',
    image: 'attila',
    side: 'left',
    education: 'PE & Sports Science Diploma',
    set: 'all abu-dhabi  ice-team',
    city: 'abh'
  },
  {
    name: 'BOHDAN BEREZENKO',
    title: 'Figure Skating Coach | Jump Specialist | Choreographer',
    flag: '🇺🇦',
    nation: 'UA',
    description: bohdan,
    citation: 'All victories begin with a victory over themselves.',
    image: 'bohdan',
    education: 'Master Degree in Physical Education and Sport',
    set: 'all abu-dhabi  ice-team',
    city: 'abh'
  },
  {
    name: 'ELEN HAMBARDZUMYAN',
    title: 'Coach | Spin Technical Analyst',
    flag: '🇦🇲',
    nation: 'AM',
    description: elen, // jsx component
    education: 'Candidate of Master of Sport Degree - Figure Skating',
    citation: 'You never fail until you stop trying.',
    image: 'elen',
    set: 'all abu-dhabi ice-team',
    city: 'abh'
  },
  {
    name: 'MARK BELKIN',
    title: 'Club Director | Figure Skating Coach',
    flag: '🇷🇺',
    nation: 'RU',
    description: mark,
    citation: 'Limitations exist only in your mind.',
    image: 'mark',
    education: 'Master Degree Figure skating',
    set: 'all dubai ice-team',
    city: 'dxb'
  },
  {
    name: 'DIANA SHAMSUTDINOVA',
    title: 'Figure Skating Coach',
    flag: '🇷🇺',
    nation: 'RU',
    description: diana,
    citation: 'Attention to detail — striving for perfection.',
    image: 'diana',
    education: 'Bachelor’s Degree in Physical Culture and Sports',
    set: 'all dubai ice-team',
    city: 'dxb'
  },
  {
    name: 'ANDREI NOVOSELOV',
    title: 'Figure Skating Coach',
    flag: '🇷🇺',
    nation: 'RU',
    description: andrei,
    citation: 'The toughest obstacles are often the ones we build ourselves.',
    image: 'andrei',
    education: 'State Certificate of Sport Instructor, Physical Education Teacher',
    set: 'all dubai ice-team',
    city: 'dxb'
  },
  {
    name: 'VERONIKA GOROKHOVA',
    title: 'Coach | Choreographer',
    flag: '🇷🇺',
    nation: 'RU',
    description: veronika, // jsx component
    education: 'Bachelor of Education, Master of Sport',
    citation: 'If you can dream it, then you can achieve it.',
    image: 'veronika',
    set: 'all dubai ice-team',
    city: 'dxb'
  },
  {
    name: 'LILIBETH BORJA VICENCIO',
    title: 'Office Manager',
    flag: '🇵🇭',
    nation: 'PH',
    description: lilibeth, // jsx component
    citation: 'Hard work has no alternative',
    image: 'lilibeth',
    side: 'left',
    set: 'all abu-dhabi management',
    city: 'abh'
  },
  {
    name: 'Jhovet Peralta',
    title: 'Office Assistant',
    flag: '🇵🇭',
    nation: 'PH',
    description: jhovet, // jsx component
    education: 'BSBA Management',
    citation: 'Optimism is a Happiness magnet. If you stay positive, good things and good people will be drawn to you.',
    image: 'jhovet',
    set: 'all dubai management',
    city: 'dxb'
  },
  {
    name: 'King Jim Castro',
    title: 'Sales Associate',
    flag: '🇵🇭',
    nation: 'PH',
    description: king, // jsx component
    education: 'Hospitality Services at “Pamantasan ng Marikina College”.',
    citation: 'Every perfect life is a parable invented by God',
    image: 'king',
    set: 'all dubai management',
    city: 'dxb'
  }
]
